// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomButton_button__1NC7U","googleSigninButton":"CustomButton_googleSigninButton__vcwwk"};